import { render, staticRenderFns } from "./UserInformationRegistration.vue?vue&type=template&id=60e8b518&scoped=true&"
import script from "./UserInformationRegistration.vue?vue&type=script&lang=js&"
export * from "./UserInformationRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8b518",
  null
  
)

export default component.exports